// extracted by mini-css-extract-plugin
module.exports = {"teamGridWrap":"team-content_teamGridWrap__wyIsk","formWrap":"team-content_formWrap__Dhp3A"};